const getBlacklist = state => {
  return state.blacklist.blacklist;
};
const getBlacklistErrors = state => {
  return state.blacklist.error;
};

export default { getBlacklist, getBlacklistErrors };
